import { gql } from '@apollo/client';
import { PEOPLE_PROFILE } from '../../fragments';

export const ALL_STAKEHOLDERS = gql`
  query AllStakeholders($input: StakeholderFilter) {
    stakeholders: getPeople(input: $input) {
      aggregate {
        count
      }
      pageInfo {
        hasNextPage
        hasPreviousPage
        startCursor
        endCursor
      }
      edges {
        node {
          id
          firstName
          lastName
          persalNumber
          nationalID
          attendance {
            id
            session {
              id
            }
            sunday
            monday
            tuesday
            wednesday
            thursday
            friday
            saturday
          }
          cohorts {
            id
            name
            isInstitutionCohort
            isInterventionCohort
            isPeopleCohort
          }
          communityType {
            id
            name
          }
          country {
            id
            name
          }
          district {
            id
            name
          }
          educatorLevel {
            id
            name
          }
          gender {
            id
            name
          }
          grades {
            id
            value
            name
          }
          highestQualification {
            id
            name
          }
          homeLanguage {
            id
            name
          }
          institutions {
            id
            name
            emisNumber
          }
          interventionRole {
            id
            name
          }
          natureOfEmployment {
            id
            name
          }
          primaryInstitution {
            id
            name
            emisNumber
          }
          phase {
            id
            name
          }
          personnelPosition {
            id
            name
          }
          personnelPositionOther
          phase {
            id
            name
          }
          populationGroup {
            id
            name
          }
          province {
            id
            name
          }
          reasonForTermination {
            id
            name
          }
          renumerationSource {
            id
            name
          }
          role {
            id
            name
          }
          subjects {
            id
            name
          }
          type {
            id
            name
          }
          ...peopleProfile
        }
        cursor
      }
    }
  }
  ${PEOPLE_PROFILE}
`;
